module.exports = __webpack_public_path__ + "static/media/tiff-pg1.be251a7a.jpg";